module.exports = __webpack_public_path__ + "img/insurance-info-icon.d93adeb7.svg";